import React from 'react';
import { ThumbsUp } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";

export const LinkToFeedBack = ({translate}) => {
    return (
        <li className="icon" title={translate("menu.feedback")}>
            <a className="button-help" target="tab" rel="noopener noreferrer" aria-label={translate("menu.feedback")} href="https://goo.gl/forms/h4f3QHVawDx2CAXm2">
                <ThumbsUp size={ICON_SIZE.MEDIUM} aria-hidden="true"/>
            </a>
        </li>
    );
}

export default LinkToFeedBack;